export default __webpack_public_path__ + "static/media/ctrlr.141b9972.jpg";